export default __webpack_public_path__ + "static/1-9e33b9cf05088681448bb3634d22f4f6.jpeg";